<section class="grid-x {{article().attributes.bg}}-content">
  <div class="container temp-spacer grid-x grid-margin-x article">
    <article class="cell large-12 article__main">
      <div class="article__content">
        <h3 class="center-text">{{article().attributes.title}}</h3>
        <p class="center-text">{{article().attributes.content}}</p>
      </div>
      <div class="article__content gallery-images">
        @for (img of images; track img.path) {
          <div class="gallery-image"
            [ngClass]="{'gallery__image--open': openImage() === img.path}"
            [ngStyle]="{'background-image': 'url(' + (img.imageDownloadPath | async) + ')'}"
            (click)="toggleFullScreen(img.path)">
          </div>
        }
      </div>
    </article>
  </div>
  @if (editMode()) {
    <div class="edit-buttons">
      <button class="button" (click)="editArticle()">edit</button>
      <button class="button" (click)="deleteArticle()">delete</button>
    </div>
  }
</section>
